"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameReducer = void 0;
const GameState_1 = require("./GameState");
const GameStateAction_1 = require("./GameStateAction");
const reducePregame = (action, state) => {
    if (GameStateAction_1.GameActions.isCreateGame(action)) {
        return GameState_1.GameStates.ReadyToPlay;
    }
    else if (GameStateAction_1.GameActions.isEndGame(action)) {
        return GameState_1.GameStates.Finished;
    }
    return state;
};
const reduceReadyToPlay = (action, state) => {
    if (GameStateAction_1.GameActions.isStartPlay(action)) {
        return GameState_1.GameStates.Playing;
    }
    else if (GameStateAction_1.GameActions.isPausePlay(action)) {
        return GameState_1.GameStates.Paused;
    }
    else if (GameStateAction_1.GameActions.isEndGame(action)) {
        return GameState_1.GameStates.Finished;
    }
    return state;
};
const reducePlaying = (action, state) => {
    if (GameStateAction_1.GameActions.isPausePlay(action)) {
        return GameState_1.GameStates.Paused;
    }
    else if (GameStateAction_1.GameActions.isResetPlay(action)) {
        return GameState_1.GameStates.Reset;
    }
    else if (GameStateAction_1.GameActions.isEndGame(action)) {
        return GameState_1.GameStates.Finished;
    }
    return state;
};
const reduceReset = (action, state) => {
    if (GameStateAction_1.GameActions.isStartPlay(action)) {
        return GameState_1.GameStates.Playing;
    }
    else if (GameStateAction_1.GameActions.isEndGame(action)) {
        return GameState_1.GameStates.Finished;
    }
    return state;
};
const reducePaused = (action, state) => {
    if (GameStateAction_1.GameActions.isStartPlay(action)) {
        return GameState_1.GameStates.Playing;
    }
    else if (GameStateAction_1.GameActions.isEndGame(action)) {
        return GameState_1.GameStates.Finished;
    }
    return state;
};
const GameReducer = (action, state) => {
    if (GameState_1.GameStates.isPreGame(state)) {
        return reducePregame(action, state);
    }
    else if (GameState_1.GameStates.isReadyToPlay(state)) {
        return reduceReadyToPlay(action, state);
    }
    else if (GameState_1.GameStates.isPlaying(state)) {
        return reducePlaying(action, state);
    }
    else if (GameState_1.GameStates.isReset(state)) {
        return reduceReset(action, state);
    }
    else if (GameState_1.GameStates.isPaused(state)) {
        return reducePaused(action, state);
    }
    return state;
};
exports.GameReducer = GameReducer;
//# sourceMappingURL=GameStateReducer.js.map